// backupDrills.api.ts — restore drill (C1): pg_restore a backup into a
// scratch database, verify it, tear it down. Never touches the live DB.
import api from "./axios";

export type BackupDrillStatus = "running" | "success" | "failed";

export interface BackupDrill {
  id: number;
  backupId: number;
  status: BackupDrillStatus;
  scratchDatabase: string;
  triggeredBy: number;
  errorMessage: string | null;
  startedAt: string;
  finishedAt: string | null;
}

export const backupDrillsApi = {
  list: () => api.get<BackupDrill[]>("/backup-drills"),
  run: (backupId: number, decryptKey: string) =>
    api.post<BackupDrill>("/backup-drills/run", { backupId, decryptKey }),
};
